import { driver } from "driver.js";
import { Formik, Form } from "formik";
import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { BaSeHeading5, BaSeInput } from "@base/react";
import { CompaniesContext } from "../../../context/companies";

const TutorialNamePlanning = () => {
  const navigate = useNavigate();
  const PAGE_KEY = "nomeDoPlanejamento";

  useEffect(() => {
    const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};
    const tutorialFinalizado = tutorials[PAGE_KEY]?.finalizado || false;
    const savedStep = tutorials[PAGE_KEY]?.step || 0;

    if (!tutorialFinalizado) {
      startTour(savedStep);
    }
  });

  const { tutorialTotalSteps } = useContext(CompaniesContext);

  const startTour = (startStep = 0) => {
    const driverObj = new driver({
      showProgress: true,
      allowClose: false,
      overlayClickNext: false,
      showButtons: ["done"],
      doneBtnText: "Próximo",
      progressText: `7 de ${tutorialTotalSteps}`,
      onPopoverRender: () => {
        setTimeout(() => {
          const popoverEl = document.querySelector(".driver-popover");

          if (!popoverEl) return;

          const finishButton = document.createElement("button");
          finishButton.innerText = "×";
          finishButton.setAttribute("aria-label", "Fechar tutorial");

          finishButton.style.position = "absolute";
          finishButton.style.top = "8px";
          finishButton.style.right = "8px";
          finishButton.style.background = "transparent";
          finishButton.style.border = "none";
          finishButton.style.fontSize = "20px";
          finishButton.style.color = "#005eb8";
          finishButton.style.cursor = "pointer";
          finishButton.style.zIndex = "9999";

          finishButton.addEventListener("click", () => {
            const tutorials =
              JSON.parse(localStorage.getItem("tutorials")) || {};

            Object.keys(tutorials).forEach((key) => {
              tutorials[key] = { ...tutorials[key], finalizado: true };
            });

            tutorials.isFinished = true;

            localStorage.setItem("tutorials", JSON.stringify(tutorials));
            driverObj.destroy();
            window.location.href = "/planejadora-sebrae";
          });

          popoverEl.appendChild(finishButton);
        }, 0);
      },
      steps: [
        {
          element: ".name-planning",
          popover: {
            title: "Nome do Planejamento",
            description: `Dê um nome ao seu planejamento para personalizar sua análise financeira. Assim, você pode organizar
            melhor suas projeções`,
            side: "bottom",
            align: "center",
          },
          onHighlighted: () => {
            const sideBar = document.querySelector(".list-menu");
            if (sideBar) {
              sideBar.classList.remove("open");
            }
          },
        },
      ],
      onHighlightStarted: () => {
        const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};
        tutorials[PAGE_KEY] = {
          ...tutorials[PAGE_KEY],
          step: driverObj.getActiveIndex(),
        };
        localStorage.setItem("tutorials", JSON.stringify(tutorials));
      },
      onDestroyed: () => {
        const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};

        if (tutorials["mediaMensal"]) {
          tutorials["mediaMensal"].finalizado = false;
        }

        tutorials[PAGE_KEY] = { ...tutorials[PAGE_KEY], finalizado: true };
        localStorage.setItem("tutorials", JSON.stringify(tutorials));

        const botaoProx = document.querySelector("#botaoSeguirTutorial button");
        botaoProx.click();
      },
    });

    driverObj.drive(startStep);
  };

  return (
    <div className="step name-planning">
      <BaSeHeading5
        color="#005EB8"
        fontFamily="Alegreya Sans"
        isBold
        className="mt-0"
      >
        Novo Planejamento
      </BaSeHeading5>
      <Formik>
        {() => (
          <Form>
            <BaSeInput
              isDisabled
              color="default"
              inputMode="text"
              typeInput="text"
              placeholder="Escolha um nome para esse planejamento"
              size="medium"
              label="Nome do planejamento"
              subLabel="(Campo obrigatório)"
              width="100%"
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TutorialNamePlanning;
